import { Controller } from '@hotwired/stimulus'

import { fetchWithHeaders } from 'utils'

declare global {
  interface Window {
    ChiliPiper: any;
  }
}

// Connects to data-controller="contact-sales-modal"
export default class extends Controller {
  static values = {
    router: { type: String, default: 'in-app-inbound-employer-router' },
    eventDetails: Object,
  }

  declare routerValue: string
  declare eventDetailsValue: Record<string, any>

  connect (): void {
    this.loadChiliPiperScript()
  }

  openModal (_event: Event): void {
    const details = this.eventDetailsValue

    this.trackEvent('clicked', details.employeeCount, details.location)

    if (window.ChiliPiper) {
      window.ChiliPiper.submit('thatch', this.routerValue, {
        trigger: 'InAppButton',
        lead: {
          PersonEmail: details.email,
          PersonFirstName: details.firstName,
          PersonLastName: details.lastName,
          CompanyName: details.companyName,
          // This weird key is the key for the field "Employee Size" in ChiliPiper
          'c5cf7539-7a42-4011-b516-f764dcaf1e50': details.employeeCount,
        },
        onSuccess: () => {
          this.trackEvent('meeting booked', details.employeeCount, details.location)

          // Post to /demos to create Demo record and send Slack notifications
          fetchWithHeaders('/demos', {
            method: 'POST',
            body: JSON.stringify({
              demo: {
                first_name: details.firstName || 'unknown',
                last_name: details.lastName || 'unknown',
                email: details.email,
                company: details.companyName,
                company_size: details.employeeCount,
              }
            }),
          })
        },
        onError: () => { this.trackEvent('routing missing', details.employeeCount, details.location) },
      })

      this.trackEvent('modal viewed', details.employeeCount, details.location)
    } else {
      this.trackEvent('chilipiper not loaded', details.employeeCount, details.location)
      throw new Error('chilipiper not loaded')
    }
  }

  private trackEvent (action: string, employeeCount: number | undefined, location: string | undefined): void {
    if (window.segment) {
      window.segment.track('Contact sales button', { action, employee_count: employeeCount, location })
    }
  }

  private loadChiliPiperScript (): void {
    // Check if the script is already loaded
    if (document.querySelector('script[src="https://thatch.chilipiper.com/concierge-js/cjs/concierge.js"]')) {
      return
    }

    const script = document.createElement('script')
    script.src = 'https://thatch.chilipiper.com/concierge-js/cjs/concierge.js'
    script.type = 'text/javascript'
    script.async = true

    document.head.appendChild(script)
  }
}
